module.exports = __webpack_public_path__ + "img/cb443901538128e847f8f6cffafabb70.png";